import { render, staticRenderFns } from "./SaleInvoiceView.vue?vue&type=template&id=025bafd1"
import script from "./SaleInvoiceView.vue?vue&type=script&lang=js"
export * from "./SaleInvoiceView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports